// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"07287f75","160":"97c170a3","208":"09566dfe","293":"3ac124ec","453":"ea72029f","516":"3caf632e","519":"f644b1b7","917":"4e91f10a","946":"3414544d"}[chunkId] + ".chunk.js";
};